function onSurveyFinish() {
  const surveyManager = document.querySelector('#survey-manager');
  const isSurveyManagerShown = surveyManager && !surveyManager.classList.contains('hide');

  if (isSurveyManagerShown) {
    const signupFormWrapper = document.querySelector('#homepage-signup-form-wrapper');

    surveyManager.classList.toggle('hide');
    signupFormWrapper.classList.toggle('hide');
  }
}

function rerender() {
  const reactOnRails = window.ReactOnRails;
  if (reactOnRails) {
    reactOnRails.render(
      'SurveyManager',
      {
        onSurveyFinish,
        showIntroductionScreen: true,
        withIndustryIdentification: window.withIndustryIdentification, // EXPERIMENT GWTH-1555
        withSeeDemoLink: window.withSeeDemoLink,
      },
      'survey-manager'
    );
  }
}

function onCloseModal() {
  rerender();
}

function setup() {
  rerender();

  // Hide modal when clicking the background
  const modalBackgroundElem = document.querySelector(
    '#survey-signup-modal-wrapper .bg-dark.modal-background'
  );
  if (modalBackgroundElem) {
    modalBackgroundElem.addEventListener('click', onCloseModal);
  }

  // Hide modal when pressing escape
  document.body.addEventListener('keydown', ({ key }) => {
    if (key === 'Escape') {
      onCloseModal();
    }
  });

  // When close icon is clicked
  const modalCloseButton = document.querySelector('#survey-signup-modal-wrapper .close');
  if (modalCloseButton) {
    modalCloseButton.addEventListener('click', onCloseModal);
  }
}

window.addEventListener('DOMContentLoaded', setup, { once: true });
